import { render } from "./AdditionalPayments.vue?vue&type=template&id=4969e80d&scoped=true"
import script from "./AdditionalPayments.vue?vue&type=script&lang=js"
export * from "./AdditionalPayments.vue?vue&type=script&lang=js"

import "./AdditionalPayments.vue?vue&type=style&index=0&id=4969e80d&scoped=true&lang=css"

import exportComponent from "/Users/alekseisemiguk/Documents/sadko/35FIT-full/35FIT/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4969e80d"]])

export default __exports__